import { message } from "antd";
import axios, { AxiosError, AxiosResponse } from "axios";
import { URL_API, username, password } from "../const-cooperativas";

export const BASE_URL = URL_API + "API/";

export class Error202 extends Error {
  constructor(public message: string) {
    super(message);
  }
}

export async function post<T = any>(
  headers: {},
  params: {},
  endpoint: string,
  apiMobile = false
): Promise<AxiosResponse<T>> {
  try {
    const response = await axios.post<T>(
      `${BASE_URL}${apiMobile ? "Mobile/" : "Site/"}${endpoint}`,
      params,
      {
        headers,
        auth: apiMobile
          ? {
              username: "usrApp",
              password: "hgFxcR5e6w3*&E5",
            }
          : {
              username,
              password,
            },
      }
    );

    if (response.status === 202) {
      throwAxiosError(response);
      throw new Error202("");
    }

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throwAxiosError(error);
    }

    return Promise.reject(error);
  }
}

export async function put<T = any>(
  headers: {},
  params: {},
  endpoint: string
): Promise<AxiosResponse<T>> {
  try {
    const response = await axios.put<T>(`${BASE_URL}Site/${endpoint}`, params, {
      headers,
      auth: {
        username,
        password,
      },
    });

    if (response.status === 202) {
      throwAxiosError(response);
      throw new Error202("");
    }

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throwAxiosError(error);
    }

    return Promise.reject(error);
  }
}

export async function get<T = any>(
  headers: {},
  endpoint: string,
  raizAPI: boolean = false
): Promise<AxiosResponse<T>> {
  try {
    const response = await axios.get<T>(
      `${BASE_URL}${raizAPI ? "" : "Site/"}${endpoint}`,
      {
        headers,
        auth: {
          username,
          password,
        },
      }
    );
    if (response.status === 202) {
      throwAxiosError(response);
      throw new Error202("");
    }

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throwAxiosError(error);
    }

    return Promise.reject(error);
  }
}

export async function remove<T = any>(
  headers: {},
  params: {},
  endpoint: string
): Promise<AxiosResponse<T>> {
  try {
    const response = await axios.delete<T>(`${BASE_URL}Site/${endpoint}`, {
      params,
      headers,
      auth: {
        username,
        password,
      },
    });

    if (response.status === 202) {
      throwAxiosError(response);
      throw new Error202("");
    }

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throwAxiosError(error);
    }

    return Promise.reject(error);
  }
}

function throwAxiosError(error: AxiosError | AxiosResponse) {
  if (axios.isAxiosError(error)) {
    if (error.response && error.response.status === 401) {
      message.error("Não autorizado");
    }
    if (error.response && error.response.status === 403) {
      message.error("Este perfil não possui acesso a esta funcionalidade");
    }
  } else if (error.status === 202) {
    message.error(error.data);
  }
}

export function parseError(error: any, msg: string) {
  console.log({ parseError: error });

  if (error && axios.isCancel(error)) {
    return;
  }

  if (error && error instanceof Error202) {
    return message.error(error.message);
  }

  if (
    error &&
    error.response &&
    error.response.status &&
    error.response.status === 401
  ) {
    return;
  }

  if (
    error &&
    error.response &&
    error.response.status &&
    error.response.status === 403
  ) {
    return;
  }

  if (error && error.response && error.response.data) {
    if (error.response.data.includes(" - "))
      return message.error(error.response.data.split(" - ")[1]);
    return message.error(error.response.data);
  }
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors &&
    error.response.data.errors.length
  ) {
    return message.error(error.response.data.errors[0]);
  }

  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors &&
    Object.keys(error.response.data.errors)
  ) {
    return message.error(
      error.response.data.errors[Object.keys(error.response.data.errors)[0]]
    );
  }

  if (msg) {
    return message.error(msg);
  }

  return "Erro inesperado";
}

export function defaultHeaders() {
  return {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
}
